'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.setConfig = setConfig;
exports.getConfig = getConfig;
exports.getExtraHeaders = getExtraHeaders;
exports.getCookies = getCookies;
exports.getOnSourceError = getOnSourceError;
var configuration = {
    API_BASE: '',
    getExtraHeaders: null,
    getCookies: null,
    onSourceError: null,
    parseErrors: null
};

function setConfig(key, value) {
    configuration[key] = value;
}

function getConfig(key) {
    if (key) {
        return configuration[key];
    }

    return configuration;
}

function getExtraHeaders() {
    var getExtraHeaders = configuration.getExtraHeaders;

    return getExtraHeaders ? getExtraHeaders() : {};
}

function getCookies() {
    var getCookies = configuration.getCookies;

    return getCookies ? getCookies() : null;
}

function getOnSourceError() {
    var onSourceError = configuration.onSourceError;

    return onSourceError ? onSourceError : function (err) {
        return console.error(err);
    };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/tg-resources/dist/init.js
 ** module id = 239
 ** module chunks = 1
 **/